import React from "react";
import { ShieldCheck } from "lucide-react";

/* Vertical timeline with optional Trust Badge per step */
export const Timeline = ({ steps }) => {
  return (
    <ol className="relative border-l-2 border-[#E0EBEB] ml-4 pl-8 py-2 space-y-10">
      {steps.map((s, idx) => (
        <li key={idx} className="relative">
          <span
            className="absolute -left-[42px] top-1 w-5 h-5 rounded-full bg-white border-[3px] border-[#0E7C7B]"
            aria-hidden
          />
          <p className="text-[11px] tracking-[0.22em] uppercase font-semibold text-[#0E7C7B]">
            Step {idx + 1}
          </p>
          <h4 className="font-serif text-xl text-[#1F2E4D] mt-1.5">{s.title}</h4>
          <p className="text-[15px] text-[#4A5568] leading-relaxed mt-2">
            {s.description}
          </p>
          {s.trust && (
            <span className="inline-flex items-center gap-2 bg-[#E0EBEB] text-[#0E7C7B] px-3 py-1.5 rounded-full text-xs font-semibold mt-3">
              <ShieldCheck className="w-3.5 h-3.5" aria-hidden />
              {s.trust}
            </span>
          )}
        </li>
      ))}
    </ol>
  );
};

export default Timeline;
